export const ROUTES = {
  ACCOUNT: '/account',
  ADD_ACTIVITIES: '/add-activities',
  ARCHIVED_BOOKS: '/archived-books',
  ATTACHED_MATERIAL: '/attached-material',
  BASE: '/',
  BOOKS: '/books',
  CATALOGUE: '/catalogue',
  CLASSROOMS: '/classrooms',
  CONFIGURE_EVALUATIONS: '/configure-evaluations',
  COURSE: '/course',
  CREATE: '/create',
  CREATED: '/created',
  EDIT: '/edit',
  EDIT_PERSONAL_DATA_CHILD: '/edit-personal-data-child',
  EDUBOOK_LEGAL_CONDITIONS: '/legal-conditions',
  EVALUATIONS: '/evaluations',
  HOME: '/home',
  ID_PARAM: '/:id',
  ID_PARAM_2: '/:param2',
  ID_PARAM_3: '/:param3',
  JOIN_CLASS: '/join-class',
  MARKS: '/marks',
  NO_ACTIVITIES: '/noActivities',
  PREVIOUS_COURSES_BOOKS: '/previous-courses-books',
  PUBLISHER_LEGAL_CONDITIONS: '/publisher-legal-conditions',
  RECOVERY_PASSWORD: '/recovery-password',
  RESET_PASSWORD: '/reset-password',
  RESOURCES: '/resources',
  SCHOOL_CODE: '/school-code',
  SELECT_STUDENT_GROUP: '/select-group/student',
  SESSION_ERROR: '/sessionError',
  STEP: '/step',
  STUDENTS: '/students',
  STUDENT_MAKE_TASK_ACTIVITIES: '/make-activities',
  SUBMISSIONS: '/submissions',
  TASKS: '/tasks',
  TEACHER_REVIEW_TASK_ACTIVITIES: '/review-activities',
  TUTOR_IA: '/tutor-ia',
  VIEW: '/view',
}
